// Original BootstrapVue 2.21.2 / Bootstrap Icons 1.2.2 SVGs, MIT.
// See BOOTSTRAPVUE-LICENSE and BOOTSTRAP-ICONS-LICENSE. Only static bundled SVGs are injected.
import { h } from 'vue'
import paths from './icon-paths.json'
export const BIcon = {
  props: { icon: String, title: String, fontScale: { default: 1 }, variant: String },
  setup: (p) => () =>
    h(
      'svg',
      {
        class: ['b-icon', 'bi', `bi-${p.icon}`, p.variant && `text-${p.variant}`],
        viewBox: '0 0 16 16',
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        xmlns: 'http://www.w3.org/2000/svg',
        focusable: 'false',
        role: 'img',
        'aria-label': p.icon?.replaceAll('-', ' '),
        style: { fontSize: Number(p.fontScale) === 1 ? undefined : `${Number(p.fontScale) * 100}%` }
      },
      [
        h('title', p.title ?? p.icon?.replaceAll('-', ' ')),
        h('g', { innerHTML: paths[p.icon] || '' })
      ]
    )
}
export const BIconArchive = { setup: () => () => h(BIcon, { icon: 'archive' }) }
export const BIconArrowDown = { setup: () => () => h(BIcon, { icon: 'arrow-down' }) }
export const BIconArrowUp = { setup: () => () => h(BIcon, { icon: 'arrow-up' }) }
export const BIconArrowsCollapse = { setup: () => () => h(BIcon, { icon: 'arrows-collapse' }) }
export const BIconArrowsExpand = { setup: () => () => h(BIcon, { icon: 'arrows-expand' }) }
export const BIconBag = { setup: () => () => h(BIcon, { icon: 'bag' }) }
export const BIconBarChart = { setup: () => () => h(BIcon, { icon: 'bar-chart' }) }
export const BIconBookmark = { setup: () => () => h(BIcon, { icon: 'bookmark' }) }
export const BIconCalendar = { setup: () => () => h(BIcon, { icon: 'calendar' }) }
export const BIconCardChecklist = { setup: () => () => h(BIcon, { icon: 'card-checklist' }) }
export const BIconCart = { setup: () => () => h(BIcon, { icon: 'cart' }) }
export const BIconChevronDoubleLeft = {
  setup: () => () => h(BIcon, { icon: 'chevron-double-left' })
}
export const BIconChevronLeft = { setup: () => () => h(BIcon, { icon: 'chevron-left' }) }
export const BIconClockHistory = { setup: () => () => h(BIcon, { icon: 'clock-history' }) }
export const BIconCloudDownload = { setup: () => () => h(BIcon, { icon: 'cloud-download' }) }
export const BIconCodeSquare = { setup: () => () => h(BIcon, { icon: 'code-square' }) }
export const BIconCollectionFill = { setup: () => () => h(BIcon, { icon: 'collection-fill' }) }
export const BIconController = { setup: () => () => h(BIcon, { icon: 'controller' }) }
export const BIconDiagram3 = { setup: () => () => h(BIcon, { icon: 'diagram3' }) }
export const BIconDisplay = { setup: () => () => h(BIcon, { icon: 'display' }) }
export const BIconEye = { setup: () => () => h(BIcon, { icon: 'eye' }) }
export const BIconFileEarmark = { setup: () => () => h(BIcon, { icon: 'file-earmark' }) }
export const BIconFileEarmarkSpreadsheet = {
  setup: () => () => h(BIcon, { icon: 'file-earmark-spreadsheet' })
}
export const BIconFileText = { setup: () => () => h(BIcon, { icon: 'file-text' }) }
export const BIconGeo = { setup: () => () => h(BIcon, { icon: 'geo' }) }
export const BIconGraphDown = { setup: () => () => h(BIcon, { icon: 'graph-down' }) }
export const BIconGrid = { setup: () => () => h(BIcon, { icon: 'grid' }) }
export const BIconInfoCircleFill = { setup: () => () => h(BIcon, { icon: 'info-circle-fill' }) }
export const BIconLaptop = { setup: () => () => h(BIcon, { icon: 'laptop' }) }
export const BIconListCheck = { setup: () => () => h(BIcon, { icon: 'list-check' }) }
export const BIconListNested = { setup: () => () => h(BIcon, { icon: 'list-nested' }) }
export const BIconListTask = { setup: () => () => h(BIcon, { icon: 'list-task' }) }
export const BIconListUl = { setup: () => () => h(BIcon, { icon: 'list-ul' }) }
export const BIconOption = { setup: () => () => h(BIcon, { icon: 'option' }) }
export const BIconPeople = { setup: () => () => h(BIcon, { icon: 'people' }) }
export const BIconShieldLock = { setup: () => () => h(BIcon, { icon: 'shield-lock' }) }
export const BIconSliders = { setup: () => () => h(BIcon, { icon: 'sliders' }) }
export const BIconTag = { setup: () => () => h(BIcon, { icon: 'tag' }) }
export const BIconTools = { setup: () => () => h(BIcon, { icon: 'tools' }) }
